import type { JSX } from "solid-js";
import { Show } from "solid-js";

type Props = {
  title: string;
  body: string;
  action?: JSX.Element;
};

function BuildingIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M4 20V9l8-5 8 5v11"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linejoin="round"
      />
      <path d="M9 20v-6h6v6" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
    </svg>
  );
}

export function IntelEmptyState(props: Props) {
  return (
    <div class="intel-empty">
      <BuildingIcon />
      <h2>{props.title}</h2>
      <p class="muted">{props.body}</p>
      <Show when={props.action}>{props.action}</Show>
    </div>
  );
}
